module.exports = __webpack_public_path__ + "img/iphone.a5f84bb.png";